
  // $('.written-reviews .grid').slick({
  //   autoplay: !0,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   dots: !1,
  //   arrows: !0,
  //   focusOnSelect: !1,
  //   lazyLoad: 'ondemand',
  //   infinite: !1,
  //   adaptiveHeight: !0,
  //   prevArrow:
  //     '<svg class="custom-slick-prev" width="25px" height="25px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path\n      fill-rule="evenodd"\n      clip-rule="evenodd"\n      d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z"\n      fill="#000000"\n    />\n  </svg>',
  //   nextArrow:
  //     '<svg class="custom-slick-next" width="25px" height="25px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path\n      fill-rule="evenodd"\n      clip-rule="evenodd"\n      d="M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z"\n      fill="#000000"\n    />\n  </svg>',
  // });


document.addEventListener('DOMContentLoaded', function () {
  var written_reviews = new window.Splide('.written-reviews .splide', {
    type: 'loop',
    autoplay: true,
    loop: true,
    arrows: true,
    pagination: false,
    snap: true,
    drag: 'free',
    focus: 'center',
    autoHeight: true,
    breakpoints: {
      480: {
        pagination: false,
        arrows: true,
        focus: 'center',
        autoHeight: true,
      },
    },
  });
  var heightMap = {};
  document.querySelectorAll('.written-reviews .splide .splide__slide').forEach(function (e) {
    e.style.maxHeight = 0;
  });
  written_reviews.on('mounted', function () {
    var i = 0;
    document.querySelectorAll('.written-reviews .splide .splide__slide').forEach(function (e) {
      if (!e.classList.contains('splide__slide--clone')) {
        heightMap[i] = e.scrollHeight;
        i++;
      }
    });
  });
  written_reviews.on('active', function (e) {
    // or e.index for non loop sliders
    var maxHeight = heightMap[e.index] + "px";
    e.slide.style.maxHeight = maxHeight;
    e.slide.parentElement.style.maxHeight = maxHeight;
  });

  written_reviews.mount();
});
